import * as React from "react"
import { Link } from "gatsby"
import Arrow from "../components/Arrow"

const BlockAdvices = ({ paddingTop = true }) => {

    return (
        <section className={paddingTop ? 'container mx-auto py-16 lg:py-36 find-more' : 'container mx-auto pb-16 lg:pb-36 find-more'}>
            <div className="max-w-5xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12">
                    <div className="rounded-xl bg-rekord-lgray p-12 flex flex-col justify-end">
                        <Link className="no-underline text-black" to="/ratgeber/magazin-hausbauer" title="Die Checkliste für deinen Hausbau">
                            <p>...gibt es viele Punkte zu berücksichtigen um dein Eigenheim zu schaffen. Deshalb ist ein glasklaren Ablauf wichtig.</p>
                            <span className="block text-3xl lg:text-4xl font-bold mb-6">
                                Wenn du gerade<br />
                                <span className="text-rekord-dorange">baust...</span>
                            </span>
                            <Arrow color="#CC6900"/>
                        </Link>
                    </div>
                    <div className="rounded-xl bg-rekord-lgray p-12 flex flex-col justify-end">
                        <Link className="no-underline text-black" to="/ratgeber/magazin-sanierung" title="Haussanierung: Wissenswertes, Tipps und Tricks">
                            <p>...willst Du Dich nachher darin wieder lang wohlfühlen. Mach dir ein genaues Bild über den Sanierungsprozess</p>
                            <span className="block text-3xl lg:text-4xl font-bold mb-6">
                                Wenn du gerade<br />
                                <span className="text-rekord-orange">sanierst...</span>
                            </span>
                            <Arrow color="#FF8400"/>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default BlockAdvices
